module.exports = __webpack_public_path__ + "static/img/playback_expire.6b628da0.png";